/**
 * Personalization fields - mostra/esconde campos conforme variante "Com personalização"
 * e seletor Letras/Imagem quando personalização está ativa
 */
(function () {
  const PERSONALIZATION_VALUE = 'Com personalização';

  function initPersonalizationFields() {
    const wrapper = document.querySelector('.m-product-info--wrapper[data-has-personalization="true"]');
    if (!wrapper) return;

    const productId = wrapper.dataset.productId;
    const productDataEl = document.querySelector('#productData[type="application/json"]');
    if (!productDataEl) return;

    let productData;
    try {
      productData = JSON.parse(productDataEl.textContent);
    } catch {
      return;
    }

    const variantPicker = wrapper.closest('.m-main-product--wrapper')?.querySelector('variant-picker');
    const letrasBlock = wrapper.querySelector('[data-personalization-type="letras"]');
    const imagemBlock = wrapper.querySelector('[data-personalization-type="imagem"]');
    const personalizationBlocks = [letrasBlock, imagemBlock].filter(Boolean);

    if (!personalizationBlocks.length) return;

    function getBlockWrapper(el) {
      return el?.closest('.main-product__block');
    }

    function isComPersonalizacao(variant) {
      if (!variant?.options) return false;
      return variant.options.some((opt) => opt && String(opt).trim() === PERSONALIZATION_VALUE);
    }

    function createTypeSelector() {
      const selector = document.createElement('div');
      selector.className = 'm-product-option m-product-option--button m-personalization-type-selector';
      selector.innerHTML = `
        <div class="m-product-option--label">
          <label class="option-label">
            <span class="option-label--title">Tipo de personalização:</span>
            <span class="option-label--selected"></span>
          </label>
        </div>
        <div class="m-product-option--content m:inline-flex m:flex-wrap">
          <div class="m-product-option--node" data-value="Letras">
            <input type="radio" id="personalization-type-letras" name="personalization-type-${productId}" value="Letras">
            <label for="personalization-type-letras" class="m-product-option--node__label">Letras</label>
          </div>
          <div class="m-product-option--node" data-value="Imagem">
            <input type="radio" id="personalization-type-imagem" name="personalization-type-${productId}" value="Imagem">
            <label for="personalization-type-imagem" class="m-product-option--node__label">Imagem</label>
          </div>
        </div>
      `;
      return selector;
    }

    function getTypeSelector() {
      return wrapper.querySelector('.m-personalization-type-selector');
    }

    function getSelectedType() {
      const sel = getTypeSelector();
      const checked = sel?.querySelector('input:checked');
      return checked ? checked.value : null;
    }

    function updateVisibility(variant) {
      const comPersonalizacao = isComPersonalizacao(variant);

      personalizationBlocks.forEach((block) => {
        const blockWrapper = getBlockWrapper(block);
        if (!blockWrapper) return;

        if (!comPersonalizacao) {
          blockWrapper.classList.add('m:hidden');
          blockWrapper.style.display = 'none';
          const input = block.querySelector('input, textarea, select');
          if (input) input.removeAttribute('required');
          return;
        }

        blockWrapper.classList.remove('m:hidden');
        blockWrapper.style.display = '';

        const type = block.dataset.personalizationType;
        const selectedType = getSelectedType();

        if (selectedType === 'Letras') {
          if (type === 'letras') {
            blockWrapper.classList.remove('m:hidden');
            blockWrapper.style.display = '';
            const input = block.querySelector('input, textarea, select');
            if (input) input.setAttribute('required', '');
          } else {
            blockWrapper.classList.add('m:hidden');
            blockWrapper.style.display = 'none';
            const input = block.querySelector('input, textarea, select');
            if (input) input.removeAttribute('required');
            const fileInput = block.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = '';
          }
        } else if (selectedType === 'Imagem') {
          if (type === 'imagem') {
            blockWrapper.classList.remove('m:hidden');
            blockWrapper.style.display = '';
            const input = block.querySelector('input, textarea, select');
            if (input) input.setAttribute('required', '');
          } else {
            blockWrapper.classList.add('m:hidden');
            blockWrapper.style.display = 'none';
            const input = block.querySelector('input, textarea, select');
            if (input) input.removeAttribute('required');
            const textInput = block.querySelector('input[type="text"], textarea');
            if (textInput) textInput.value = '';
          }
        } else {
          blockWrapper.classList.add('m:hidden');
          blockWrapper.style.display = 'none';
          const input = block.querySelector('input, textarea, select');
          if (input) input.removeAttribute('required');
        }
      });

      const typeSelector = getTypeSelector();
      if (typeSelector) {
        typeSelector.classList.toggle('m:hidden', !comPersonalizacao);
        typeSelector.style.display = comPersonalizacao ? '' : 'none';
      }
    }

    function ensureTypeSelector() {
      let typeSelector = getTypeSelector();
      if (!typeSelector) {
        typeSelector = createTypeSelector();
        const firstBlock = getBlockWrapper(letrasBlock || imagemBlock);
        if (firstBlock) {
          firstBlock.parentNode.insertBefore(typeSelector, firstBlock);
        }
      }

      typeSelector.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.replaceWith(radio.cloneNode(true));
      });

      const newRadios = typeSelector.querySelectorAll('input[type="radio"]');
      newRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const selectedSpan = typeSelector.querySelector('.option-label--selected');
          if (selectedSpan) selectedSpan.textContent = radio.value;
          const vp = wrapper.closest('.m-main-product--wrapper')?.querySelector('variant-picker');
          const v = vp?.currentVariant || productData?.variants?.[0];
          if (v) updateVisibility(v);
        });
      });
    }

    function onVariantChange(variant) {
      const comPersonalizacao = isComPersonalizacao(variant);
      if (comPersonalizacao) {
        ensureTypeSelector();
        const typeSelector = getTypeSelector();
        const selected = typeSelector?.querySelector('input:checked');
        if (!selected) {
          const first = typeSelector?.querySelector('input');
          if (first) {
            first.checked = true;
            const span = typeSelector?.querySelector('.option-label--selected');
            if (span) span.textContent = first.value;
          }
        }
      }
      updateVisibility(variant);
    }

    if (window.MinimogEvents) {
      window.MinimogEvents.subscribe(`${productId}__VARIANT_CHANGE`, onVariantChange);
    }

    document.addEventListener('variant:changed', (e) => {
      if (e.detail?.variant) onVariantChange(e.detail.variant);
    });

    const productWrapper = wrapper.closest('.m-main-product--wrapper');
    const form = productWrapper?.querySelector('form[data-type="add-to-cart-form"]') || productWrapper?.querySelector('product-form form');
    const variantIdInput = productWrapper?.querySelector('input[name="id"]:not([disabled])') || form?.querySelector('input[name="id"]');
    const currentVariantId = variantIdInput ? Number(variantIdInput.value) : null;
    const initialVariant =
      (currentVariantId && productData.variants?.find((v) => v.id === currentVariantId)) ||
      productData.selected_or_first_available_variant ||
      productData.variants?.[0];
    setTimeout(() => onVariantChange(initialVariant), 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonalizationFields);
  } else {
    initPersonalizationFields();
  }

  if (Shopify?.designMode) {
    document.addEventListener('shopify:section:load', initPersonalizationFields);
  }
})();
